import { Button, Checkbox, Popover } from '@bb/ui';

export interface ListColumn<Id extends string> {
  id: Id;
  label: string;
}

/** Optional columns of a list (campaigns, Canvas); the choice is saved per employee by the page. */
export function ColumnsPicker<Id extends string>({ columns, value, onChange }: { columns: readonly ListColumn<Id>[]; value: readonly Id[]; onChange: (next: Id[]) => void }) {
  const toggle = (id: Id, on: boolean) => onChange(columns.map((c) => c.id).filter((c) => (c === id ? on : value.includes(c))));
  return (
    <Popover label="Columns" trigger={<Button variant="ghost">Columns</Button>}>
      <fieldset className="columns-picker">
        <legend>Columns</legend>
        {columns.map((c) => (
          <Checkbox key={c.id} label={c.label} checked={value.includes(c.id)} onCheckedChange={(on) => toggle(c.id, on)} />
        ))}
      </fieldset>
    </Popover>
  );
}
